import React from 'react';
import {
    View,
    StyleSheet,
} from 'react-native';
import TrackingWorkoutTotalsDashboard from '../components/tracking-workout-totals-dashboard';
import { TrackingPieChartDashboard } from '../components/tracking-dashboard-pie-chart';
import { translate } from 'react-i18next';

class TrackingTotalWorkoutDashboardTile extends React.Component {

    render() {
        return (
            <View style={styles.container}>
                {this.props.totals.total !== 0 &&
                    <TrackingPieChartDashboard data={this.props.totals} />
                }
                <TrackingWorkoutTotalsDashboard totals={this.props.totals} />
            </View>

        )
    }
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 20,
        alignContent: 'center',
        alignItems: 'center',
        marginTop: -8
    },
});

export default translate(['workoutHistory'])(TrackingTotalWorkoutDashboardTile);
